import { ReactNode } from 'react';

type Item = {
  label: ReactNode;
  id: string;
  href?: string;
  isComplete?: boolean;
  isDisabled?: boolean;
};

export default function inferFields(items: Item[], active: string) {
  const activeItemIndex = items.findIndex(i => i.id === active);

  return items.map((item, i) => {
    if (item.id === active) {
      return item;
    }
    return {
      ...item,
      isComplete: item.isComplete === undefined ? activeItemIndex > i : item.isComplete,
      isDisabled: item.isDisabled === undefined ? activeItemIndex < i : item.isDisabled,
    };
  });
}
